<template>
  <div class="sk-anon-wrapper">
    <div class="devNote">v_3.4.2</div>
    <transition :name="transitionName" mode="">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      transitionName: 'sk-fade'
    }
  },
  mounted: function () {
    var el = document.getElementById('preloadr')
    if (el) {
      el.style.transition = 'opacity 0.5s'
      el.style.opacity = '0'
      setTimeout(function () { el.style.display = 'none' }, 500)
    }
  },
  created: function () {
    this.$router.beforeEach((to, from, next) => {
      if (from.path === '/signup' || to.path === '/forgotpassword') this.transitionName = 'sk-slide-left'
      else this.transitionName = 'sk-slide-right'
      next()
    })
  }
}
</script>

<style>
.sk-anon-wrapper {
  min-height: 100vh;
  background: #f0f4f9;
}

.sk-anon-wrapper .devNote {
  display: none;
}

.sk-fade-enter-active,
.sk-fade-leave-active {
  transition: opacity 0.3s ease;
}
.sk-fade-enter,
.sk-fade-leave-to {
  opacity: 0;
}

.sk-slide-left-enter-active,
.sk-slide-left-leave-active,
.sk-slide-right-enter-active,
.sk-slide-right-leave-active {
  transition: all 0.3s ease;
}

.sk-slide-left-enter {
  opacity: 0;
  transform: translateX(30px);
}
.sk-slide-left-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.sk-slide-right-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.sk-slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>



// WEBPACK FOOTER //
// AnonUserPage.vue?50440478